import { AbstractControl } from '@angular/forms';

export class CustomValidations {

  static MatchPassword(AC: AbstractControl) {
    const password = AC.get('password').value; // to get value in input tag
    const confirmPassword = AC.get('repeat_password').value; // to get value in input tag
    if (password !== confirmPassword) {
      AC.get('repeat_password').setErrors({ MatchPassword: true });
    } else {
      return null;
    }
  }

  static MatchChangePassword(AC: AbstractControl){
    const newPassword = AC.get('newPassword').value; // to get value in input tag
    const confirmPassword = AC.get('confirm_Password').value; // to get value in input tag
    if(newPassword !== confirmPassword){
      AC.get('confirm_Password').setErrors({MatchChangePassword: true});
    }else{
      return null;
    }
  }

  static MatchResetPassword(AC: AbstractControl){
    const password = AC.get('password').value; // accessing the 'password' control
    const confirmPassword = AC.get('confirm_password').value; // accessing the 'confirm_password' control
    if(password !== confirmPassword){
      AC.get('confirm_password').setErrors({MatchResetPassword: true});
    } else {
      return null;
    }
  }

}
